/**
 * @desc 生成随机数
 */
export const createRandomNumber = () => {
    return parseInt(String(Math.random() * 10000000000000));
};

/**
 * @desc 获取 localstoreage data
 */
export function localStoreData<T>(localstoreageKey: string): [T | undefined, (setValue: T) => void] {
    const data = localStorage.getItem(localstoreageKey);

    const value = data ? (JSON.parse(data) as T) : undefined;

    const setHandle = (setValue: T) => localStorage.setItem(localstoreageKey, JSON.stringify(setValue));

    return [value, setHandle];
}

/**
 *
 * @param molecule 分子
 * @param denominator 分母
 * @returns number
 */
export function cptRation(molecule: number, denominator: number) {
    const result = (molecule / denominator) * 100;

    return Number(result.toFixed(2));
}

export type NumberListType = number[];

export const getTripleSize = (arr: NumberListType): NumberListType => {
    const tripleSize = Math.ceil(arr.length / 3) * 3;
    const result = Array(tripleSize).fill(null); // 生成新数组，初始值为 null
    arr.forEach((value, index) => {
        result[index] = value;
    });
    return result;
};

/**
 *
 * @param obj 值
 * @returns boolean
 */
function isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') return true;
    return false;
}

export function preProcessData(formData: { [key: string]: any }) {
    Object.keys(formData).forEach((item) => {
        if (isEmpty(formData[item])) {
            delete formData[item];
        }
    });
    return formData;
}

/**
 * 解密protobuf信息
 * @param bytes
 * @param value
 * @returns
 */
export function getXor(bytes: Uint8Array, value: number): Uint8Array {
    if (value < 0) {
        value = value & 0xff;
    }
    for (let i = 0; i < bytes.length; i++) {
        let iData;
        if (bytes[i] < 0) {
            iData = bytes[i] & 0xff;
        } else {
            iData = bytes[i];
        }
        bytes[i] = (iData ^ value) & 0xff;
    }
    return bytes;
}

/**
 * 从多语言中获取名称
 * @param str
 * @param lang
 * @returns
 */
export function getNameFromLanguage(str: string, lang = 'zh_CN') {
    try {
        const names = JSON.parse(str);
        return names[lang];
    } catch {
        return str;
    }
}

/**
 * 校验是否为整数类型
 * @param value
 * @returns
 */
export function validateInt(value: string) {
    const reg = /^-?\d+$/;
    return reg.test(value);
}

/**
 * 校验是否为数字类型（小数，负数，整数）
 * @param value
 * @returns
 */
export function validateNumber(value: string) {
    const reg = /^-?\d+(?:(\.|,)\d+)?$/;
    return reg.test(value);
}

/**
 * 校验小数点后位数
 * @param value
 * @param length
 * @returns
 */
export function validateDecimalLength(value: string, length: number) {
    const reg = new RegExp(`^-?\\d+((\\.|,)\\d{1,${length}})?$`);
    return reg.test(value);
}

// 处理字符串中的英文逗号，空格，换行
export function handleSNListString(content?: string) {
    if (!content) return undefined;
    return content
        ?.replace(/[,\s\n]/g, '-')
        ?.split('-')
        ?.filter((item) => item !== '');
}

// 下拉框匹配
export const filterOption = (input: string, option: { label: string; value: string } | undefined) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

/**
 *
 * @desc 对象数组结构化成对象
 * @param items
 * @param filedKey 对象 key 字段名
 * @param filedValue 对象 value 字段名
 * @returns
 *
 * @example
 * const ple = [
 *  {indexName: 'yoy', indexValue: 2024},
 *  {indexName: 'mon', indexValue: 2025},
 * ]
 * ====>
 * {yoy: 2024, mon: 2025}
 *
 */
export function arrayToMap<T>(items: Record<string, any>[], filedKey: string, filedValue: string): T {
    return items.reduce((total, item) => {
        const key = item[filedKey];

        const value = item[filedValue];

        total[key] = value;

        return total;
    }, {}) as T;
}
export const getBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
